export const APP_NAME = "merchant";
